import React from "react";
import "./Label.scss";

interface LabelProps {
  htmlFor?: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const Label: React.FC<LabelProps> = ({ htmlFor, children, className = "", style }) => {
  return (
    <label htmlFor={htmlFor} className={`label ${className}`} style={style}>
      {children}
    </label>
  );
};
